var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1100 438L1100 466",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1100.5,
    cy: 433.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.1 442C1096.64 442 1096.24 441.834 1095.9 441.501C1095.57 441.168 1095.4 440.768 1095.4 440.3C1095.4 439.833 1095.57 439.432 1095.9 439.099C1096.24 438.766 1096.64 438.6 1097.1 438.6C1097.57 438.6 1097.97 438.766 1098.31 439.099C1098.64 439.432 1098.81 439.833 1098.81 440.3C1098.81 440.768 1098.64 441.168 1098.31 441.501C1097.97 441.834 1097.57 442 1097.1 442ZM1105.61 442C1105.14 442 1104.74 441.834 1104.41 441.501C1104.08 441.168 1103.91 440.768 1103.91 440.3C1103.91 439.833 1104.08 439.432 1104.41 439.099C1104.74 438.766 1105.14 438.6 1105.61 438.6C1106.08 438.6 1106.48 438.766 1106.81 439.099C1107.15 439.432 1107.31 439.833 1107.31 440.3C1107.31 440.768 1107.15 441.168 1106.81 441.501C1106.48 441.834 1106.08 442 1105.61 442ZM1096.38 428.4L1098.42 432.65H1104.38L1106.72 428.4H1096.38ZM1095.57 426.7H1108.12C1108.45 426.7 1108.7 426.845 1108.87 427.136C1109.04 427.426 1109.04 427.72 1108.89 428.018L1105.87 433.457C1105.71 433.741 1105.5 433.96 1105.24 434.116C1104.98 434.272 1104.69 434.35 1104.38 434.35H1098.04L1097.1 436.05H1107.31V437.75H1097.1C1096.47 437.75 1095.98 437.47 1095.66 436.911C1095.33 436.351 1095.32 435.795 1095.62 435.242L1096.76 433.16L1093.7 426.7H1092V425H1094.77L1095.57 426.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping1);
export default __webpack_public_path__ + "static/media/shopping_1.4a41a12811ae4e7dd934559941ed267e.svg";
export { ForwardRef as ReactComponent };